import { notify } from 'react-notify-toast';

const TIMEOUT = 5000;

// custom colors
const ERROR_COLOR = { background: '#F8D0C5', text: "#FFFFFF" };

export const showErrorToast = (message) => {
  notify.show(message, 'custom', TIMEOUT, ERROR_COLOR);
}


// WEBPACK FOOTER //
// ./src/utilities/notificationUtils.js